import React, { useState } from 'react';
import { UploadIcon, RulerIcon, CompassIcon, SettingsIcon } from 'lucide-react';
interface UploadDrawingProps {
  onNext: () => void;
}
export const UploadDrawing: React.FC<UploadDrawingProps> = ({
  onNext
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    // Handle file drop logic here
  };
  return <div className="mb-20" data-id="element-355">
      <div className="bg-white rounded-xl shadow-sm p-6 mb-6" data-id="element-356">
        <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-357">
          Upload tegning
        </h2>
        <div className={`
            border-2 border-dashed rounded-lg p-10 text-center cursor-pointer
            ${isDragging ? 'border-[#E3000F] bg-red-50' : 'border-gray-300 hover:border-gray-400'}
            transition-colors duration-200
          `} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} onClick={() => document.getElementById('file-upload')?.click()} data-id="element-358">
          <input id="file-upload" type="file" className="hidden" accept=".pdf,.dwg,.ifc" data-id="element-359" />
          <UploadIcon className="w-12 h-12 mx-auto text-gray-400 mb-4" data-id="element-360" />
          <h3 className="text-lg font-medium text-gray-700 mb-2" data-id="element-361">
            Drag & drop eller klik for at uploade
          </h3>
          <p className="text-gray-500 mb-2" data-id="element-362">
            Understøttede formater: PDF, DWG, IFC
          </p>
          <p className="text-sm text-gray-400" data-id="element-363">Max. filstørrelse: 25MB</p>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm p-6 mb-6" data-id="element-364">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-365">
          Indstillinger
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-366">
          <div className="space-y-2" data-id="element-367">
            <div className="flex items-center" data-id="element-368">
              <RulerIcon className="w-5 h-5 text-gray-500 mr-2" data-id="element-369" />
              <label className="text-gray-700 font-medium" data-id="element-370">Målestok</label>
            </div>
            <div className="flex" data-id="element-371">
              <input type="number" className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" placeholder="1.0" data-id="element-372" />
              <select className="px-3 py-2 border border-l-0 border-gray-300 rounded-r-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" data-id="element-373">
                <option data-id="element-374">m/pixel</option>
                <option data-id="element-375">mm/pixel</option>
              </select>
            </div>
          </div>
          <div className="space-y-2" data-id="element-376">
            <div className="flex items-center" data-id="element-377">
              <CompassIcon className="w-5 h-5 text-gray-500 mr-2" data-id="element-378" />
              <label className="text-gray-700 font-medium" data-id="element-379">Orientering</label>
            </div>
            <select className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" data-id="element-380">
              <option data-id="element-381">Nord op</option>
              <option data-id="element-382">Syd op</option>
              <option data-id="element-383">Øst op</option>
              <option data-id="element-384">Vest op</option>
            </select>
          </div>
          <div className="space-y-2" data-id="element-385">
            <div className="flex items-center" data-id="element-386">
              <SettingsIcon className="w-5 h-5 text-gray-500 mr-2" data-id="element-387" />
              <label className="text-gray-700 font-medium" data-id="element-388">Reference-mål</label>
            </div>
            <div className="flex" data-id="element-389">
              <input type="number" className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" placeholder="1000" data-id="element-390" />
              <select className="px-3 py-2 border border-l-0 border-gray-300 rounded-r-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" data-id="element-391">
                <option data-id="element-392">mm</option>
                <option data-id="element-393">cm</option>
                <option data-id="element-394">m</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm p-6 mb-6" data-id="element-395">
        <div className="flex items-start" data-id="element-396">
          <div className="flex-1" data-id="element-397">
            <p className="text-gray-600 text-sm" data-id="element-398">
              <strong className="font-medium" data-id="element-399">AI udtrækker automatisk:</strong>{' '}
              etager, rumkonturer, arealer, ikke-opvarmede zoner og foreslår
              system & c/c.
            </p>
          </div>
          <button onClick={onNext} className="px-6 py-2 bg-[#E3000F] text-white font-medium rounded-md hover:bg-red-700 transition-colors" data-id="element-400">
            Kør AI-udtræk
          </button>
        </div>
      </div>
    </div>;
};